import React from 'react';
import Immutable from 'immutable';

import CombinedHighlightedEntities from '../../../components/CombinedHighlightedEntities';

const ENTITIES_VIEW_DISPLAY = 'latest_stories';

const ParagraphSelectedStories = ({ id, entity, ...args }) => {
  const isLargeVariant = entity.getIn(['field_is_large_variant', 0, 'value'], false);
  const selectedEntities = entity.getIn(['field_selected_stories'], Immutable.List()).map((entry) => entry.get('entity'));
  const storyTypeIds = entity.getIn(['field_story_types'], Immutable.List()).map((entry) => entry.get('target_id', null)).toJS();
  const subjectIds = entity.getIn(['field_subjects'], Immutable.List()).map((entry) => entry.get('target_id', null)).toJS();

  return (
    <div id={id}>
      <CombinedHighlightedEntities
        isLargeVariant={isLargeVariant}
        contentProps={{
          type: 'stories',
          link: entity.getIn(['field_link', 0, 'alias'], '/nl/verhalen'),
          title: entity.getIn(['field_title', 0, 'value']),
        }}
        selectedEntities={selectedEntities}
        viewDisplay={ENTITIES_VIEW_DISPLAY}
        viewFilters={{
          field_story_type_target_id: storyTypeIds,
          field_subjects_target_id: subjectIds,
        }}
        viewArgs={[args.nid]}
        key="combined_highlighted_stories"
      />
    </div>
  );
};
export default ParagraphSelectedStories;
